import { makeAutoObservable } from "mobx"

export default class ProjectManager {

  constructor(projectManager={}) {
    this.id = projectManager.id
    this.first_name = projectManager.first_name || ''
    this.last_name = projectManager.last_name || ''
    this.email = projectManager.email || ''
    this.password = ''
    this.password_confirmation = ''
    this.is_admin = !!projectManager.is_admin


    makeAutoObservable(this)
  }
}
